
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store-feed",
      function () {
        return require("private-next-pages/store-feed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store-feed"])
      });
    }
  